


















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
// import { ipcRenderer } from 'electron'
import jump from 'jump.js'
import Editor from '@/components/Editor.vue'
import { MessageModel } from '../views/connections/types'
import convertPayload from '@/utils/convertPayload'
import { v4 as uuidv4 } from 'uuid'

@Component({
  components: {
    Editor,
  },
})
export default class MsgPublish extends Vue {
  @Prop({ required: true }) public editorHeight!: number
  @Prop({ required: true }) public subsVisible!: boolean

  private msgRecord: MessageModel = {
    mid: '',
    createAt: '',
    out: true,
    qos: 0,
    retain: false,
    topic: '',
    payload: JSON.stringify({ msg: 'hello' }, null, 2),
  }

  private payloadLang = 'plaintext'
  private payloadType: PayloadType = 'Hex'
  private payloadOptions: PayloadType[] = ['Hex','Plaintext', 'Base64', 'JSON']

  @Watch('editorHeight')
  private handleHeightChanged() {
    this.handleLayout()
  }
  @Watch('subsVisible')
  private handleSubsChanged(val: boolean) {
    setTimeout(() => {
      this.handleLayout()
    }, 500)
  }
  @Watch('payloadType')
  private handleTypeChange(val: PayloadType, oldVal: PayloadType) {
    const { payload } = this.msgRecord
    convertPayload(payload, val, oldVal)
      .then(res => {
        this.msgRecord.payload = res
        if (val === 'JSON') {
          this.payloadLang = 'json'
        } else {
          this.payloadLang = 'plaintext'
        }
      })
      .catch((error: Error) => {
        const errorMsg = error.toString()
        this.$message.error(errorMsg)
        this.payloadType = oldVal
      })
  }

  private send() {
    this.msgRecord.mid = uuidv4()
    this.$emit('handleSend', this.msgRecord, this.payloadType)
  }

  private handleInputFoucs() {
    // ipcRenderer.on('sendPayload', () => {
    //   this.send()
    // })
    jump(document.body.scrollHeight)
  }
  private handleInputBlur() {
    // ipcRenderer.removeAllListeners('sendPayload')
  }
  private handleLayout() {
    const editorRef: EditorRef = this.$refs.payloadEditor as EditorRef
    editorRef.editorLayout()
  }

  private beforeDestroy() {
    // ipcRenderer.removeAllListeners('sendPayload')
  }
}
